import React, { useEffect, useState } from "react";
import banner1 from "../../../assets/images/banners/Website cover page.jpeg";
import explore_products_1 from "../../../assets/images/dummy/explore_products_1.png";
import explore_products_2 from "../../../assets/images/dummy/explore_products_2.jpeg";
import new_arrival_img1 from "../../../assets/images/dummy/new_arrival_img1.jpeg";
import new_arrival_sm_img1 from "../../../assets/images/dummy/new_arrival_sm_img1.jpeg";
import new_arrival_sm_img2 from "../../../assets/images/dummy/new_arrival_sm_img2.jpeg";

import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "./index.css";
import { Button, Col, Container, Row } from "react-bootstrap";
import { NavLink, useNavigate } from "react-router-dom";
import YUsStripComponent from "../../common/Y_us_strip";
import axios from "axios";
import Constants from "../../Variables/Constants";
import Y_Us_StripComponent from "../../common/Y_us_strip";
import Loader from "../../../components/Loader";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { setCartItems } from "../../../redux/cartSlice";
function HomePagesComponet() {
  const navigate = useNavigate();
  const [getAllCategory, setCategory] = useState([]);
  const [bagCategory, setBagCategory] = useState("");

  const getData = async () => {
    try {
      axios.get(Constants.getUrls.getAllCategory).then((resp) => {
        if (resp.data.status == "success") {
          const data = resp.data.data.docs;
          if (data && Array.isArray(data) && data.length > 0) {
            setCategory(data);
            const titlesToFind = [
              "Tallis/Tefillin Bags",
              "Custom Passover Sets",
            ];

            const bagCategories = titlesToFind
              .map((title) => data.find((item) => item.title === title))
              .filter(Boolean);
            console.log("bagCategory", bagCategories);
            setBagCategory(bagCategories);
          }
        }
      });
    } catch (error) {
      try {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
        const { status, message } = error.response.data;
        if (status === 401 && message === "Unauthorized!") {
          localStorage.removeItem("token");
          window.location.href = "/";
        }
      } catch (error) {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
      }
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const ExploreProductsOptions = {
    navText: [
      "<i className='bi bi-chevron-left'><</i>",
      "<i className='bi bi-chevron-right'>></i>",
    ],
    autoplay: true,
    items: getAllCategory.length,
    loop: true,
    nav: true,
    dots: false,
    navStyle: {
      ".owl-prev": { left: "-25px" },
      ".owl-next": { right: "-25px" },
    },
    responsive: {
      1: {
        items: 1,
        margin: 10,
      },
      450: {
        items: 2,
        margin: 10,
      },
      600: {
        items: 2,
        margin: 10,
      },
      750: {
        items: 3,
        margin: 10,
      },
      1000: {
        items: 3,
        margin: 15,
      },
      1225: {
        items: 4,
        margin: 20,
      },
      1300: {
        items: 4,
        margin: 30,
      },
      1500: {
        items: 5,
        margin: 30,
      },
    },
  };

  if (getAllCategory.length <= 0) {
    return <Loader />;
  }
  function logCoords(e) {
    const rect = e.target.getBoundingClientRect();
    const x = Math.round(e.clientX - rect.left);
    const y = Math.round(e.clientY - rect.top);
    console.log(x, y);
  }
  return (
    <>
      <section
        className="home_banner_slider position-relative "
        style={{
          width: "100vw",
          marginLeft: "calc(-50vw + 50%)",
        }}
      >
        <div className=" position-relative w-100" style={{ width: "100vw" }}>
          <OwlCarousel
            items={1}
            margin={8}
            autoplay={false}
            dots={true}
            loop={false}
            nav={false}
            className="w-100"
            style={{ width: "100vw" }}
          >
            {bagCategory?.map((category, index) => (
              <div
                key={index}
                className="home_banner position-relative w-100 border-0"
              >
                <img
                  src={`${category.slug}-cover.png`}
                  alt={category.slug}
                  className="img-fluid border-0 rounded-0"
                  loading="eager"
                  fetchPriority="high"
                  decoding="sync"
                  onClick={logCoords}
                />

                <NavLink
                  to={`/category?catid=${category?._id}`}
                  state={{ ...category }}
                  className=" position-absolute w-12 h-12 m-4 d-flex align-items-center home_banner_button "
                >
                  {/* Begin to build your custom betail
                <i className="ms-2 bi bi-chevron-right"></i> */}
                </NavLink>
              </div>
            ))}

            {/* 
            <div className="home_banner">
              <img loading="lazy" src={banner1} alt="banner-1" />
              <NavLink
                to={`/category?catid=${bagCategory?._id}`}
                state={{ ...bagCategory }}
                className=" position-absolute w-12 h-12 m-4 d-flex align-items-center home_banner_button "
              >
                Begin to build your custom betail
                <i className="ms-2 bi bi-chevron-right"></i>
              </NavLink>
            </div>
            <div className="home_banner">
              <img loading="lazy" src={banner1} alt="banner-1" />
              <NavLink
                to={`/category?catid=${bagCategory?._id}`}
                state={{ ...bagCategory }}
                className=" position-absolute w-12 h-12 m-4 d-flex align-items-center home_banner_button "
              >
                Begin to build your custom betail
                <i className="ms-2 bi bi-chevron-right"></i>
              </NavLink>
            </div> */}
          </OwlCarousel>
        </div>
      </section>
      <section className="section_padding home_explore_our_products">
        <div className="px-5">
          <div className="d-flex mb-3">
            <h2 className="hdng1">Explore Our Products</h2>
            {/* Custom carousel slider buttons */}
            {/* <div className="custom-carousel-buttons">
              <button className="prev-button">Prev</button>
              <button className="next-button">Next</button>
            </div> */}
          </div>

          <Row>
            <Col>
              <OwlCarousel {...ExploreProductsOptions} className="owl-theme">
                {getAllCategory.map((category, i) => (
                  <NavLink to={`/category?catid=${category._id}`} key={i}>
                    <div className="explore_our_products_card mx-auto text-center mb-0">
                      <img
                        loading="lazy"
                        src={Constants.imgDomain + category.category}
                        alt={category.title}
                        className="img-fluid"
                        style={{
                          width: "100%",
                          height: "250px",
                          objectFit: "cover"
                        }}
                      />
                      <span className="product_name mx-auto">
                        {category.title}
                      </span>
                    </div>
                  </NavLink>
                ))}
              </OwlCarousel>

              {/* </OwlCarousel> */}
            </Col>
          </Row>
         
        </div>
      </section>

      {/* <section className=" new_arrival_featured">
        <div className="px-5">
          <div className="d-flex mb-3">
            <div className="hdng_sm_bg">
              <h5>Featured</h5>
              <h2 className="">New Arrival</h2>
            </div>
          </div>
          <Row className="g-3">
            <Col lg="6">
              <div className="new_arrival_featured1">
                <img loading="lazy"  width="100%" src={new_arrival_img1} />
                <div className="txt_cntnt">
                  <h4 className="fs-30">ACCESSORIES TALLIS & TEFILLEN BATEL</h4>
                  <p>
                    Plastic Protector Black Leather Look Back for Talis and
                    Tefilin Batel + Handle
                  </p>
                  <Button
                    type="button"
                    onClick={() => navigate(`/category?catid=${bagCategory?._id}`)}
                  >Shop Now</Button>
                </div>
              </div>
            </Col>
            <Col lg="6">
              <Row className="g-3">
                <Col xs="12">
                  <div className="new_arrival_featured2">
                    <Row className="gx-0 align-items-center">
                      <Col sm="6">
                        <div className="txt_cntnt">
                          <h4 className="fs-30">Waterproof Tefillin Batel</h4>
                          <p>Waterproof, with handle and pocket inside.</p>
                          <Button
                            type="button"
                            onClick={() => navigate(`/category?catid=${bagCategory?._id}`)}
                          >Shop Now</Button>
                        </div>
                      </Col>
                      <Col sm="6">
                        <img loading="lazy"  width="100%" src={new_arrival_sm_img1} />
                      </Col>
                    </Row>
                  </div>
                </Col>
                <Col xs="12">
                  <div className="new_arrival_featured3">
                    <Row className="gx-0 align-items-center">
                      <Col sm="6">
                        <div className="txt_cntnt">
                          <h4 className="text-uppercase fs-30">
                            CUSTOM TALLIS & TEFILLEN BATEL
                          </h4>
                          <Button
                            type="button"
                            onClick={() => navigate(`/category?catid=${bagCategory?._id}`)}
                          >Create Custom Batel</Button>
                        </div>
                      </Col>
                      <Col sm="6">
                        <img loading="lazy"  width="100%" src={new_arrival_sm_img2} />
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </section> */}

      {/* <Y_Us_StripComponent /> */}
    </>
  );
}

export default HomePagesComponet;
